import type { CSSProperties, ReactNode } from 'react';

export type NgBreadcrumbsProps = {
  children?: ReactNode;
  divider?: string;
};

export function NgBreadcrumbs({ children, divider }: NgBreadcrumbsProps) {
  const effectiveDividerStyle =
    divider == null ? undefined : ({ '--bs-breadcrumb-divider': `'${divider}'` } as CSSProperties);

  return (
    <nav aria-label="breadcrumb" style={effectiveDividerStyle}>
      <ol
        className="breadcrumb"
        style={{ '--bs-breadcrumb-margin-bottom': '0.5rem' } as CSSProperties}
      >
        {children}
      </ol>
    </nav>
  );
}
